/* PaintMyMemory theme helpers (Dawn base). No dependencies, no external calls. */
(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  /* ------------------------------------------------------------ cart helpers */
  const cartEl = () => document.querySelector('cart-drawer');

  async function pbnAddItems(items, button) {
    if (!items.length) return null;
    const drawer = cartEl();
    const body = { items };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }
    if (button) {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
    }
    try {
      const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      };
      const res = await fetch(window.routes ? window.routes.cart_add_url : '/cart/add', {
        ...config,
        body: JSON.stringify(body),
      }).then((r) => r.json());
      if (res.status) {
        window.alert(res.description || res.message || 'Could not add to cart');
        return null;
      }
      if (drawer && res.sections) {
        drawer.renderContents(res);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pbn', cartData: res });
        }
      } else {
        window.location = window.routes ? window.routes.cart_url : '/cart';
      }
      return res;
    } catch (e) {
      console.error(e);
      return null;
    } finally {
      if (button) {
        button.removeAttribute('aria-disabled');
        button.classList.remove('loading');
      }
    }
  }
  window.pbnAddItems = pbnAddItems;

  // Drawer upsell quick-add (drawer HTML is re-rendered, so delegate)
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-pbn-quick-add]');
    if (!form) return;
    event.preventDefault();
    const id = Number(form.querySelector('[name="id"]').value);
    const quantity = Number(form.querySelector('[name="quantity"]')?.value || 1);
    pbnAddItems([{ id, quantity }], form.querySelector('button'));
  });

  // Frequently-bought-together "Add selected" button
  const addonInputs = (formId) => $$(`input[data-pbn-addon][data-form-id="${formId}"]`);
  document.addEventListener('change', (event) => {
    const input = event.target.closest('input[data-pbn-addon]');
    if (!input) return;
    const formId = input.dataset.formId;
    const btn = $(`[data-pbn-addons-add="${formId}"]`);
    if (btn) btn.disabled = !addonInputs(formId).some((i) => i.checked);
  });
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-pbn-addons-add]');
    if (!btn) return;
    const formId = btn.dataset.pbnAddonsAdd;
    const checked = addonInputs(formId).filter((i) => i.checked);
    pbnAddItems(checked.map((i) => ({ id: Number(i.value), quantity: 1 })), btn).then((res) => {
      if (!res) return;
      checked.forEach((i) => (i.checked = false));
      btn.disabled = true;
    });
  });

  // Track order form: open tracker with the number
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-pbn-track]');
    if (!form) return;
    event.preventDefault();
    const value = form.querySelector('[name="nums"]').value.trim();
    if (!value) return;
    window.open(`${form.action}#nums=${encodeURIComponent(value)}`, '_blank', 'noopener');
  });

  /* ------------------------------------------------------------ photo upload */
  const APP_UPLOADER_SELECTORS = [
    'input[type="file"]:not(.pbn-upload__input)',
    '[class*="uploadkit" i]',
    '[id*="uploadkit" i]',
    '[class*="upload-kit" i]',
    '[data-uploadkit]',
    '[class*="uploadcare" i]',
    'uc-file-uploader-regular',
    'lr-file-uploader-regular',
  ].join(',');

  class PbnPhotoUpload extends HTMLElement {
    connectedCallback() {
      this.input = $('.pbn-upload__input', this);
      this.empty = $('.pbn-upload__empty', this);
      this.preview = $('.pbn-upload__preview', this);
      this.thumb = $('.pbn-upload__thumb', this);
      this.nameEl = $('.pbn-upload__name', this);
      this.statusEl = $('.pbn-upload__status', this);
      this.warn = $('.pbn-upload__warn', this);
      this.error = $('.pbn-upload__error', this);
      this.drop = $('.pbn-upload__drop', this);
      this.maxPx = Number(this.dataset.maxPx || 4000);
      this.minPx = Number(this.dataset.minPx || 1200);
      this.required = this.dataset.required === 'true';
      this.busy = false;
      this.pendingSubmit = false;

      this.input.addEventListener('change', () => this.onFile());
      ['dragenter', 'dragover'].forEach((t) =>
        this.drop.addEventListener(t, (e) => {
          e.preventDefault();
          this.drop.classList.add('is-drag');
        })
      );
      ['dragleave', 'drop'].forEach((t) => this.drop.addEventListener(t, () => this.drop.classList.remove('is-drag')));
      this.drop.addEventListener('drop', (e) => {
        e.preventDefault();
        if (e.dataTransfer && e.dataTransfer.files.length) {
          try {
            this.input.files = e.dataTransfer.files;
            this.onFile();
          } catch (err) {
            console.warn(err);
          }
        }
      });

      if (this.dataset.mode !== 'always') this.watchForApp();
    }

    get disabled() {
      return this.hidden || this.input.disabled;
    }

    watchForApp() {
      const root = this.closest('.product__info-container') || document;
      const check = () => {
        const found = $$(APP_UPLOADER_SELECTORS, root).some((el) => !this.contains(el));
        if (found) this.yieldToApp();
        return found;
      };
      if (check()) return;
      this.observer = new MutationObserver(() => check() && this.observer.disconnect());
      this.observer.observe(root, { childList: true, subtree: true });
      setTimeout(() => this.observer && this.observer.disconnect(), 15000);
    }

    yieldToApp() {
      this.hidden = true;
      $$('input, textarea', this).forEach((el) => (el.disabled = true));
      document.dispatchEvent(new CustomEvent('pbn:upload-app'));
    }

    hasFile() {
      return this.input.files && this.input.files.length > 0;
    }

    validate() {
      if (this.disabled) return true;
      if (this.busy) {
        this.pendingSubmit = true;
        this.statusEl.textContent = 'Preparing your photo…';
        return false;
      }
      if (this.required && !this.hasFile()) {
        this.error.hidden = false;
        this.classList.add('is-error');
        this.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }
      return true;
    }

    async onFile() {
      const file = this.input.files && this.input.files[0];
      this.error.hidden = true;
      this.classList.remove('is-error');
      this.warn.hidden = true;
      if (!file) {
        this.preview.hidden = true;
        this.empty.hidden = false;
        document.dispatchEvent(new CustomEvent('pbn:photo', { detail: { hasFile: false } }));
        return;
      }
      this.empty.hidden = true;
      this.preview.hidden = false;
      this.nameEl.textContent = file.name;
      this.statusEl.textContent = '';
      if (this.thumbUrl) URL.revokeObjectURL(this.thumbUrl);
      this.thumbUrl = URL.createObjectURL(file);
      this.thumb.src = this.thumbUrl;
      document.dispatchEvent(new CustomEvent('pbn:photo', { detail: { hasFile: true } }));

      let bitmap = null;
      try {
        bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' });
      } catch (e) {
        bitmap = null; // HEIC etc. on browsers that cannot decode it: upload as-is
      }
      if (!bitmap) {
        this.statusEl.textContent = 'Ready';
        return;
      }
      const { width, height } = bitmap;
      this.setOrientation(width >= height ? 'Landscape' : 'Portrait');
      if (Math.min(width, height) < this.minPx && this.dataset.lowres) {
        this.warn.textContent = this.dataset.lowres;
        this.warn.hidden = false;
      }

      const tooBig = Math.max(width, height) > this.maxPx || file.size > 15 * 1024 * 1024;
      if (!tooBig || typeof DataTransfer === 'undefined') {
        this.statusEl.textContent = `${width}×${height}px · Ready`;
        bitmap.close && bitmap.close();
        return;
      }

      this.busy = true;
      this.statusEl.textContent = 'Optimizing…';
      try {
        const scale = Math.min(1, this.maxPx / Math.max(width, height));
        const canvas = document.createElement('canvas');
        canvas.width = Math.round(width * scale);
        canvas.height = Math.round(height * scale);
        canvas.getContext('2d').drawImage(bitmap, 0, 0, canvas.width, canvas.height);
        const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', 0.92));
        if (blob) {
          const name = file.name.replace(/\.[^.]+$/, '') + '.jpg';
          const dt = new DataTransfer();
          dt.items.add(new File([blob], name, { type: 'image/jpeg', lastModified: Date.now() }));
          this.input.files = dt.files;
          this.nameEl.textContent = name;
          this.statusEl.textContent = `${canvas.width}×${canvas.height}px · Ready`;
        } else {
          this.statusEl.textContent = 'Ready';
        }
      } catch (e) {
        console.warn('pbn resize skipped', e);
        this.statusEl.textContent = 'Ready';
      } finally {
        bitmap.close && bitmap.close();
        this.busy = false;
        if (this.pendingSubmit) {
          this.pendingSubmit = false;
          const form = document.getElementById(this.dataset.formId);
          form && form.querySelector('[type="submit"]')?.click();
        }
      }
    }

    setOrientation(value) {
      const radio = $(`input[name="properties[Orientation]"][value="${value}"]`, this);
      if (radio && !this.orientationTouched) radio.checked = true;
      if (!this.orientationBound) {
        this.orientationBound = true;
        $$('input[name="properties[Orientation]"]', this).forEach((r) =>
          r.addEventListener('change', () => (this.orientationTouched = true))
        );
      }
    }
  }
  if (!customElements.get('pbn-photo-upload')) customElements.define('pbn-photo-upload', PbnPhotoUpload);

  /* ------------------------------------------------------------ before / after */
  class PbnBeforeAfter extends HTMLElement {
    connectedCallback() {
      this.frame = $('.pbn-ba__frame', this);
      this.range = $('.pbn-ba__range', this);
      const set = (pct) => {
        const v = Math.max(0, Math.min(100, pct));
        this.style.setProperty('--pos', `${v}%`);
        this.range.value = v;
      };
      const fromEvent = (e) => {
        const r = this.frame.getBoundingClientRect();
        set(((e.clientX - r.left) / r.width) * 100);
      };
      this.frame.addEventListener('pointerdown', (e) => {
        if (e.target.closest('.pbn-ba__inset')) return;
        this.dragging = true;
        this.frame.setPointerCapture(e.pointerId);
        fromEvent(e);
      });
      this.frame.addEventListener('pointermove', (e) => this.dragging && fromEvent(e));
      ['pointerup', 'pointercancel'].forEach((t) => this.frame.addEventListener(t, () => (this.dragging = false)));
      this.range.addEventListener('input', () => set(Number(this.range.value)));
      set(50);
    }
  }
  if (!customElements.get('pbn-before-after')) customElements.define('pbn-before-after', PbnBeforeAfter);

  /* ------------------------------------------------------------ sale countdown */
  class PbnCountdown extends HTMLElement {
    connectedCallback() {
      this.end = new Date(this.dataset.end);
      this.out = $('[data-countdown]', this);
      if (isNaN(this.end.getTime())) return;
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
    }
    tick() {
      const ms = this.end - Date.now();
      if (ms <= 0) {
        this.hidden = true;
        clearInterval(this.timer);
        return;
      }
      const s = Math.floor(ms / 1000);
      const d = Math.floor(s / 86400);
      const hh = String(Math.floor((s % 86400) / 3600)).padStart(2, '0');
      const mm = String(Math.floor((s % 3600) / 60)).padStart(2, '0');
      const ss = String(s % 60).padStart(2, '0');
      this.out.textContent = `${d > 0 ? d + 'd ' : ''}${hh}:${mm}:${ss}`;
      this.hidden = false;
    }
  }
  if (!customElements.get('pbn-countdown')) customElements.define('pbn-countdown', PbnCountdown);

  /* ------------------------------------------------------------ delivery estimate */
  const TZ = 'America/New_York';
  function nyNow() {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: TZ, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hourCycle: 'h23',
    }).formatToParts(new Date());
    const get = (t) => Number(parts.find((p) => p.type === t).value);
    return { y: get('year'), m: get('month'), d: get('day'), h: get('hour'), min: get('minute') };
  }
  const isBiz = (date) => date.getUTCDay() !== 0 && date.getUTCDay() !== 6;
  const addDays = (date, n) => new Date(date.getTime() + n * 86400000);
  function addBiz(date, n) {
    let d = date;
    let left = n;
    while (left > 0) {
      d = addDays(d, 1);
      if (isBiz(d)) left -= 1;
    }
    return d;
  }
  const fmt = (date, opts) => new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', ...opts }).format(date);
  function fmtRange(a, b) {
    if (a.getUTCMonth() === b.getUTCMonth()) return `${fmt(a, { month: 'short' })} ${a.getUTCDate()}–${b.getUTCDate()}`;
    return `${fmt(a, { month: 'short', day: 'numeric' })} – ${fmt(b, { month: 'short', day: 'numeric' })}`;
  }

  class PbnShipDates extends HTMLElement {
    connectedCallback() {
      this.render();
      this.timer = setInterval(() => this.render(), 60000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
    }
    render() {
      const prod = Number(this.dataset.prod || 0);
      const min = Number(this.dataset.min || 5);
      const max = Number(this.dataset.max || 10);
      const cutoff = Number(this.dataset.cutoff || 14);
      const now = nyNow();
      const today = new Date(Date.UTC(now.y, now.m - 1, now.d, 12));
      const nowMin = now.h * 60 + now.min;

      let start = today;
      let daysAhead = 0;
      if (!isBiz(today) || nowMin >= cutoff * 60) {
        do {
          daysAhead += 1;
          start = addDays(today, daysAhead);
        } while (!isBiz(start));
      }
      const leftMin = daysAhead * 1440 + cutoff * 60 - nowMin;
      const ship = addBiz(start, prod);
      const from = addBiz(ship, min);
      const to = addBiz(ship, max);

      const set = (sel, text) => $$(sel, this).forEach((el) => (el.textContent = text));
      set('[data-date="today"]', fmt(today, { month: 'short', day: 'numeric' }));
      set('[data-date="ship"]', fmt(ship, { weekday: 'short', month: 'short', day: 'numeric' }));
      set('[data-date="deliver"]', fmtRange(from, to));
      set('[data-date="deliver-short"]', fmtRange(from, to));
      set('[data-date="deliver-late-long"]', fmt(to, { weekday: 'long', month: 'long', day: 'numeric' }));
      const h = Math.floor(leftMin / 60);
      const m = leftMin % 60;
      set('[data-cutoff-left]', h > 0 ? `${h}h ${m}m` : `${m}m`);
      const headline = $('[data-headline]', this);
      if (headline) headline.hidden = false;
    }
  }
  if (!customElements.get('pbn-ship-dates')) customElements.define('pbn-ship-dates', PbnShipDates);

  /* ------------------------------------------------------------ sticky add to cart */
  class PbnStickyAtc extends HTMLElement {
    connectedCallback() {
      this.info = document.querySelector('product-info[id^="MainProduct"]');
      if (!this.info) return;
      this.form = $('form[data-type="add-to-cart-form"]', this.info);
      this.mainBtn = this.form && $('[type="submit"]', this.form);
      if (!this.mainBtn) return;
      this.btn = $('[data-sticky-btn]', this);
      this.priceOut = $('[data-sticky-price]', this);
      this.label = this.btn.textContent.trim();
      this.upload = document.querySelector(`pbn-photo-upload[data-form-id="${this.form.getAttribute('id')}"]`);

      this.btn.addEventListener('click', () => {
        if (this.needsPhoto()) {
          this.upload.scrollIntoView({ behavior: 'smooth', block: 'center' });
          this.upload.input.click();
          return;
        }
        this.mainBtn.click();
      });

      const priceEl = $('[id^="price-"]', this.info);
      if (priceEl) {
        const copy = () => {
          const onSale = priceEl.querySelector('.price--on-sale');
          const item = priceEl.querySelector('.pmm-price__now') || priceEl.querySelector(onSale ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular');
          if (item && item.textContent.trim()) this.priceOut.textContent = item.textContent.trim();
        };
        copy();
        new MutationObserver(copy).observe(priceEl, { childList: true, subtree: true, characterData: true });
      }

      const syncLabel = () => (this.btn.textContent = this.needsPhoto() ? this.btn.dataset.uploadLabel || this.label : this.label);
      document.addEventListener('pbn:photo', syncLabel);
      document.addEventListener('pbn:upload-app', syncLabel);
      syncLabel();

      new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting;
        this.hidden = !show;
        document.body.classList.toggle('pbn-sticky-on', show);
      }).observe(this.mainBtn);
    }
    needsPhoto() {
      return !!(this.upload && !this.upload.disabled && this.upload.required && !this.upload.hasFile());
    }
  }
  if (!customElements.get('pbn-sticky-atc')) customElements.define('pbn-sticky-atc', PbnStickyAtc);
})();
